import { Box, styled } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { LwButton } from 'redesign';
import { useDebounce } from 'shared/hooks/use-debounce';
import { SearchInput } from 'shared/components/search-input';
import { IconAdd } from 'assets/img';
import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CompaniesFilterParams, SetCompaniesFilterParams } from '../../companies.types';

export const CompaniesFilterToolbox = ({
  params,
  setParams,
}: {
  params: CompaniesFilterParams;
  setParams: SetCompaniesFilterParams;
}) => {
  const [filter, setFilter] = useState<string | undefined>(params.filter);
  const debouncedFilter = useDebounce(filter, 300);
  const { t } = useTranslation('hq-screen-specific');

  useEffect(() => {
    setParams({ filter: debouncedFilter ?? undefined });
  }, [debouncedFilter]);

  const redirectPath = useMemo(() => {
    const queryParams = new URLSearchParams({
      filter: params.filter ?? '',
    }).toString();

    return generatePath('create') + (queryParams ? `?${queryParams}` : '');
  }, [params.filter]);

  return (
    <ToolboxWrapper>
      <Box flex={1}>
        <LwButton to={redirectPath} startIcon={<IconAdd />} color="primary" iconColorMode="fill">
          {t('companies.create.button')}
        </LwButton>
      </Box>
      <Box flex={1}>
        <SearchInput
          value={filter}
          onChange={setFilter}
          placeholder="Bedrijfsnaam"
          enableKeyboardShortcut
        />
      </Box>
    </ToolboxWrapper>
  );
};

const ToolboxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(6),
}));
